import { event } from '@uhg-abyss/web/tools/event';
import { logger } from '@uhg-abyss/web/tools/logger';
import { config } from '@uhg-abyss/web/tools/config';
import {
  addElasticApmLabels,
  validateAndInitializeElasticApm,
} from '@src/app/tools/analytics/elasticApm/helpers';

export const elasticApmAnalytics = (options) => {
  if (options.enabled !== false) {
    const { hostname } = window.location;
    const eapmEnv = config('EAPM_ENV');
    const serverUrl =
      hostname === 'apps.uhcprovider.com'
        ? 'https://eapm-gw.uhc.com'
        : 'https://eapm-gw-nonprod.uhc.com';

    const initParams = {
      serverUrl,
      environment: `register-ui:${eapmEnv}`,
      serviceName: config('ELASTIC_APM_SERVICE_NAME'),
    };

    return {
      id: options.id,
      events: options.events,
      metadata: options.metadata,
      trigger: (tag) => {
        if (options.logging) {
          logger.warn(`Elastic APM: ${tag.event}`, tag.data);
        }

        event.waitFor(
          () => {
            return validateAndInitializeElasticApm(initParams);
          },
          () => {
            addElasticApmLabels(tag);
          }
        );
      },
    };
  }
  return {};
};
